module.exports = __webpack_public_path__ + "static/media/bmx-intro.803485c5.mov";